<template>
  <div class="row">
    <div class="col">
      <div v-if="settings_data.status === 'connected'" class="dashboard-card no-height">
        <z-form ref="form" v-slot="{ failed }">
          <div class="row mx-1 mb-3 widget-tab__field">
            <div class="title">
              {{ $t('integrations.settings.account.settings.main.children.domain.title') }}
            </div>
            <div class="widget-tab__title">
              {{ settings_data.base_domain }}
            </div>
            <tooltip
              class="ml-3"
              placement="top"
              min-width="200"
              max-width="200"
              theme="light"
              :content="
                $t('integrations.settings.account.settings.main.children.domain.description')
              "
            >
              <icon size="18" type="ios-help-circle-outline" />
            </tooltip>
          </div>

          <div class="row mx-1 mb-3 widget-tab__field">
            <div class="title">
              {{ $t('integrations.settings.account.settings.main.children.amo_login.title') }}
            </div>
            <div class="widget-tab__title">
              {{ settings_data.amo_login }}
            </div>
            <tooltip
              class="ml-3"
              placement="top"
              min-width="200"
              max-width="200"
              theme="light"
              :content="
                $t('integrations.settings.account.settings.main.children.amo_login.description')
              "
            >
              <icon size="18" type="ios-help-circle-outline" />
            </tooltip>
          </div>

          <div class="row mx-1 mb-3">
            <div class="title">
              {{ $t('integrations.settings.account.settings.main.children.status.title') }}
            </div>
            <div>
              <div :class="`badge badge--connected`">
                {{ $t(`integrations.statuses.${settings_data.status}`) }}
              </div>
            </div>
          </div>

          <template v-if="failed">
            <div class="mt-4 mailing-description__error">
              {{ $t('validator.std_form_error') }}
            </div>
          </template>
        </z-form>
      </div>
      <div v-else-if="settings_data.status === 'disconnected'">
        <div class="amo-card">{{ $t('integrations.page.button.not_connected') }}</div>
      </div>
      <div v-else>
        <div class="amo-card">{{ $t('integrations.page.button.loading') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AmoService } from '@amo-widget/services/AmoService';

  export default {
    data: () => ({
      settings_data: {
        amo_login: '',
        widget_config: {}
      }
    }),
    async mounted() {
      this.settings_data = await AmoService.getSettingsData();
    }
  };
</script>
